<template>
  <div v-if="shouldShowPrompt" class="fixed inset-0 z-50 overflow-y-auto">
    <!-- Backdrop -->
    <div class="fixed inset-0 bg-black/20 backdrop-blur-[1.5px] transition-opacity"></div>

    <!-- Modal -->
    <div class="flex min-h-full items-center justify-center p-4">
      <div class="relative w-full max-w-md rounded-xl bg-white shadow-menu">
        <div class="flex flex-col gap-2 mx-4 my-10">
          <p class="text-normal-emphasis font-bold">
            <span v-if="offlineReady">
              App ready to work offline
            </span>
            <span v-else-if="isReloading">
              Updating app...
            </span>
            <span v-else>
              New content available, click on reload button to update.
            </span>
          </p>
          <AppButton
            :title="isReloading ? 'Updating...' : 'Reload'"
            :disabled="isReloading"
            @click="reload"
          />
          <AppCancel v-if="!isReloading" @click="close" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import useServiceWorkerReload from "@/modules/useServiceWorkerReload";
import { onMounted, onUnmounted } from "vue";

const intervalMS = 10 * 60 * 1000;

const {
  offlineReady,
  isReloading,
  shouldShowPrompt,
  reload,
  close,
  startWatching,
  stopWatching
} = useServiceWorkerReload(intervalMS);

// Start watching when component mounts
onMounted(() => {
  const tryStartWatching = async () => {
    if ('serviceWorker' in navigator) {
      try {
        // Wait for service worker to be ready
        const registration = await navigator.serviceWorker.ready;
        startWatching(registration);
      } catch (error) {
        console.warn('Service worker not ready, retrying in 2 seconds...', error);
        // Retry after 2 seconds if service worker isn't ready
        setTimeout(tryStartWatching, 2000);
      }
    }
  };

  tryStartWatching();
});

// Stop watching when component unmounts
onUnmounted(() => {
  stopWatching();
});
</script>
